/**
 * @generated SignedSource<<9d84a31fa179ad710f9e920154f4f767>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AttachedContentTodoUnlinkProductMutation$variables = {
  productId: string;
  todoId: string;
};
export type AttachedContentTodoUnlinkProductMutation$data = {
  readonly todo: {
    readonly unlinkProduct: {
      readonly linkedProducts: ReadonlyArray<{
        readonly id: string;
      }>;
    };
  } | null;
};
export type AttachedContentTodoUnlinkProductMutation = {
  response: AttachedContentTodoUnlinkProductMutation$data;
  variables: AttachedContentTodoUnlinkProductMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "productId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "todoId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "todoId",
    "variableName": "todoId"
  }
],
v3 = [
  {
    "kind": "Variable",
    "name": "productId",
    "variableName": "productId"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "StoreProduct",
  "kind": "LinkedField",
  "name": "linkedProducts",
  "plural": true,
  "selections": [
    (v4/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "AttachedContentTodoUnlinkProductMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "TodoMutation",
        "kind": "LinkedField",
        "name": "todo",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "Todo",
            "kind": "LinkedField",
            "name": "unlinkProduct",
            "plural": false,
            "selections": [
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "AttachedContentTodoUnlinkProductMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "TodoMutation",
        "kind": "LinkedField",
        "name": "todo",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "Todo",
            "kind": "LinkedField",
            "name": "unlinkProduct",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3f449610c58a2fea0c1da582cd3a5a94",
    "id": null,
    "metadata": {},
    "name": "AttachedContentTodoUnlinkProductMutation",
    "operationKind": "mutation",
    "text": "mutation AttachedContentTodoUnlinkProductMutation(\n  $todoId: ID!\n  $productId: ID!\n) {\n  todo(todoId: $todoId) {\n    unlinkProduct(productId: $productId) {\n      linkedProducts {\n        id\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "64d9e751133ac52cdfe6860a50e16e8a";

export default node;
